<template>
    <div class="container mt-5 margin_80_35 ">
        <div class="row pt-4">
            <div class="col-lg-12" v-if="newslist.length > 0">
                <div class="row">
                    <div class="col-12">
                        <carousel :data="{ 'items': newslist, 'type': 'News' }"></carousel>
                    </div>
                </div>
                <div class="mb-4 mt-4 container-title">
                    <h3>Latest News & Announcements</h3>
                </div>
                <article class="wow fadeIn mb-5" style="visibility: visible; animation-name: fadeIn;"
                    v-for="(newslistitem, index) in newslist" :key="index">
                    <div class="row no-gutters">
                        <div class="post_info d-flex">
                            <div>
                                <img class="blog-img"
                                    :src="newslistitem.Image ? sharedDirectory + 'NewsImage/' + newslistitem.Image : sharedDirectory + 'DefaultImages/image_not_available.png'"
                                    alt="No Image">
                            </div>
                            <div class="ml-4">
                                <small><i class="fa fa-clock-o" aria-hidden="true"></i> {{ new
                                    Date(newslistitem.CreateDate).toLocaleDateString() }} <i
                                        class="ml-1 fa fa-pencil-square-o" aria-hidden="true"></i>
                                    {{ newslistitem.UserName }}</small>
                                <h5><router-link
                                        :to="{ name: 'NewsDetails', params: { Id: newslistitem.ID }, }">{{ newslistitem.Title }}</router-link>
                                </h5>
                                <p class="mb-0">{{ newslistitem.PreviewDescription }}</p>
                            </div>
                        </div>
                    </div>
                </article>
                <!-- /article -->
            </div>
            <!-- /col -->
        </div>
        <!-- /row -->
    </div>
</template>

<script>
import NewsService from '../services/news.service'
import Carousel from '../components/Common/carousel'

export default {
  name: 'News',
  data() {
    return {
      newslist: [],
      sharedDirectory: process.env.VUE_APP_SHARED_DIRECTORY
    }
  },
  components: {
    Carousel
  },
  filters: {
    truncate: function (text, length) {
      if (text.length > length) {
        return text.substring(0, length) + '...'
      } else {
        return text
      }
    },
  },
  mounted() {
    this.getNews()
  },
  methods: {
    getNews() {
      NewsService.getNewsList().then(response => {
        this.newslist = response.data.Object.newsList	
      }),
      error => {
        console.log(error)
      }
    }
  }
}
</script>

